import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMurexinPimContextApi } from '../../../../api';
import { NotificationContext } from '../../../../contexts';
import PIMFormikSidebar from '../../../../shared/Components/PIMFormikSidebar';
import PIMFormikTextField from '../../../../shared/Components/PIMFormikTextField';

interface IProps {
  productPriceImportFile: File;
  onSubmit: () => void;
  onCancel: () => void;
}

type PriceImport = {
  file: File;
  fileName: string;
  year?: number;
};

export default function ProductCatalogPriceImportSidebar(props: IProps): JSX.Element {
  const { t } = useTranslation();
  const classes = useStyles();
  const api = useMurexinPimContextApi();
  const notification = React.useContext(NotificationContext);

  if (!props.productPriceImportFile) return <></>;

  const getNextYear = (): number => {
    const currentYear = new Date().getFullYear();
    return currentYear + 1;
  };

  const nextYear = getNextYear();
  const priceImport: PriceImport = {
    file: props.productPriceImportFile,
    fileName: props.productPriceImportFile.name,
    year: nextYear,
  };

  const handleOnSubmit = async (values: PriceImport) => {
    try {
      if (values) {
        const priceImportRequest = {
          Year: values.year,
          File: values.file,
        };
        await api.admin.adminImportImportProductCatalogPricesCreate(priceImportRequest);
      }
      notification.success(t('Speichern erfolgreich'));
    } catch (error) {
      notification.error(t('Produktkatalog Preisimport fehlgeschlagen'));
    }
    props.onSubmit();
  };

  return (
    <PIMFormikSidebar
      title={t('Preise importieren')}
      cancelButtonText={t('Abbrechen')}
      formikInitialValues={priceImport}
      handleOnSubmit={handleOnSubmit}
      handleOnCancel={props.onCancel}
      allowSubmitOnDirty>
      <Grid container>
        <PIMFormikTextField
          name='fileName'
          id='fileName'
          label={t('Ausgewählte Datei')}
          className={classes.fileNameField}
          type='text'
          disabled
        />
      </Grid>
    </PIMFormikSidebar>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    line: {
      margin: '16px 0px 24px 0px',
    },
    yearSelect: {
      '&.MuiFormControl-root': {
        marginTop: '0px',
      },
    },
    fileNameField: {
      flex: 1,
      padding: theme.spacing(0, 0, 0, 0),
    },
  })
);
